import { render } from "./sysSet.vue?vue&type=template&id=4d7caaf2"
import script from "./sysSet.vue?vue&type=script&lang=js"
export * from "./sysSet.vue?vue&type=script&lang=js"

import "./sysSet.vue?vue&type=style&index=0&id=4d7caaf2&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__